module.exports = __webpack_public_path__ + "img/476-e43a4b.png";